import type { Member } from '@wix/ambassador-blog-frontend-adapter-public-v2-post-page/types';
import { blogAppDefId } from '../constants/apps';

export const getUserRoleByApp = (user: Member | undefined, appDefinitionId: string) =>
  user?.appStore?.[appDefinitionId]?.permissions?.role;
export const getUserRole = (user: Member | undefined) => getUserRoleByApp(user, blogAppDefId);
